import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import Icon from 'components/Icon';
import { getTimerBackgroundColor } from 'features/timer/utils/getTimerBackgroundColor';
import { TimerMode } from 'features/timer/types';

export type TimerPillProps = {
  currentSeconds: number;
  isActive: boolean;
  formattedTime: string;
  mode?: TimerMode;
  fullWidth?: boolean;
};

const TimerPill = memo(
  ({
    currentSeconds,
    isActive,
    formattedTime,
    mode = 'countdown',
    fullWidth = false,
  }: TimerPillProps) => (
    <Box
      sx={{
        display: fullWidth ? 'flex' : 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        p: 2,
        borderRadius: '8px',
        backgroundColor: getTimerBackgroundColor(currentSeconds, isActive),
        color: 'common.white',
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      <Icon sx={{ fontSize: 24 }} name={mode === 'countdown' ? 'timer' : 'stop-watch'} />
      <Typography
        variant="body2"
        component="span"
        sx={{
          textAlign: 'center',
          minWidth: '60px',
          fontFamily: 'monospace',
        }}
      >
        {formattedTime}
      </Typography>
    </Box>
  )
);

export default TimerPill;
